/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';

export const videoIframeHolder = css({
  display: 'flex',
  justifyContent: 'center',
  [MediaQueries.sm]: { display: '-webkit-box' },

  '.youtube-holder': {
    [MediaQueries.sm]: { width: '100%' },
  },

  '.preloaderCss': {
    [MediaQueries.sm]: { width: '100%' },
  },

  '.youtube-holder div': {
    display: 'flex',
    justifyContent: 'center',

    [MediaQueries.sm]: { height: '70vh' },
    [MediaQueries.md]: { height: '70vh' },
    [MediaQueries.lg]: { height: '70vh' },
  },
});
export const showVideo = css({
  iframe: {
    display: 'block',
  },
});

export const preloaderCss = css({
  // marginTop: '100px',
  justifyContent: 'center',
  textAlign: 'center',
  '.load-wraper': {
    position: 'relative',
    height: '100%',
    width: '100%',
    backgroundColor: 'rgb(211,211,211)',
    zIndex: 44,
    overflow: 'hidden',
    borderRadius: '5px',
  },
  '.activity': {
    position: 'absolute',
    left: '-45%',
    height: '100%',
    width: '45%',
    backgroundImage: [
      'linear-gradient(to left, rgba(251,251,251, .05), rgba(251,251,251, .3), rgba(251,251,251, .6), rgba(251,251,251, .3), rgba(251,251,251, .05))',
      '-moz-linear-gradient(to left, rgba(251,251,251, .05), rgba(251,251,251, .3), rgba(251,251,251, .6), rgba(251,251,251, .3), rgba(251,251,251, .05))',
      '-webkit-linear-gradient(to left, rgba(251,251,251, .05), rgba(251,251,251, .3), rgba(251,251,251, .6), rgba(251,251,251, .3), rgba(251,251,251, .05))',
    ],
    animation: 'loading 1s infinite',
    zIndex: 45,
  },
  '@keyframes loading': { '0%': { left: '-45%' }, '100%': { left: '100%' } },
});

export const videoHolder = css({
  // position: 'absolute',
  // top: 0,
  // bottom: 0,
  // right: 0,
  // left: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginTop: '100px',
  [MediaQueries.xl]: { marginTop: '50px' },
  [MediaQueries.sm]: { marginTop: '50px' },

  iframe: {
    display: 'none',
  },

  '.close_btnsec': {
    width: '1058px',
    margin: '0 auto',
    outline: 'none',
    [MediaQueries.xl]: { width: '1058px' },
    [MediaQueries.lg]: { width: '900px' },
    [MediaQueries.md]: { width: '600px' },
    [MediaQueries.sm]: { width: '100%', paddingRight: '15px' },

    button: {
      position: 'relative',
      zIndex: 999999,
      display: 'flex',
      justifyContent: 'flex-end',
      background: 'transparent',
      border: '0',

      cursor: 'pointer',
      width: '100%',
      float: 'right',
      outline: '67px',
      padding: '15px 0px',

      [MediaQueries.sm]: { maxWidth: '67px' },
      [MediaQueries.xl]: { maxWidth: '67px' },
      [MediaQueries.lg]: { maxWidth: '67px' },

      i: {
        marginRight: '10px',
      },
    },
  },

  '.preloaderCss ,iframe': {
    height: '602px',
    width: '1058px',
    [MediaQueries.xl]: { width: '1058px' },
    [MediaQueries.md]: {
      height: 'inherit',
      width: '600px',
    },

    [MediaQueries.lg]: {
      height: 'inherit',
      width: '900px',
    },

    [MediaQueries.sm]: {
      height: 'inherit',
      width: '100%',
    },
  },
});
